import React from "react";
import { useNavigate } from "react-router-dom";
import logoTransparent from "../../assets/images/logo/logo_transparent.png";
import { removeToken } from "../../utils/cookies";
import { PaperIcon, ResultIcon, UploadIcon, PaymentIcon, FileIcon } from "../../assets/icons";

const Sidebar = ({
  isOpen,
  onClose,
  currentPath,
  onLogout,
  isMobile = true,
}) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "upload",
      label: "New Essay",
      path: "/upload",
     icon: <UploadIcon />,
      isDefault: true,
    },
    {
      id: "past-paper",
      label: "Past Model Papers",
      path: "/past-paper",
      icon: <PaperIcon />,
    },
    {
      id: "results",
      label: "Results",
      path: "/results",
      icon: <ResultIcon />,
    },
    {
      id: "plans-management",
      label: "Plans Management",
      path: "/payment",
      icon: <PaymentIcon />,
    },
    {
      id: "history",
      label: "History",
      path: "/history",
      icon: <FileIcon />,
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      onClose();
    }
  };

  if (isMobile) {
    return (
      <>
        {isOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
            onClick={onClose}
          />
        )}

        <div
          className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex flex-col h-full">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div className="flex items-center">
                <img
                  src={logoTransparent}
                  alt="Calbar Logo"
                  className="h-12 w-auto"
                />
              </div>
              <button
                onClick={onClose}
                className="p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <nav className="flex-1 px-4 py-6 space-y-2">
              {menuItems.map((item) => {
                const isActive =
                  currentPath === item.path ||
                  (item.isDefault && currentPath === "/");
                return (
                  <button
                    key={item.id}
                    onClick={() => handleNavigation(item.path)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
                      isActive
                        ? "bg-primary-50 text-primary-700 border-l-4 border-primary-600"
                        : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                    }`}
                  >
                    <span
                      className={`${
                        isActive ? "text-primary-600" : "text-gray-400"
                      }`}
                    >
                      {item.icon}
                    </span>
                    <span className="font-medium">{item.label}</span>
                  </button>
                );
              })}
            </nav>

            <div className="p-4 border-t border-gray-200">
              <button
                onClick={() => {
                  onClose();
                  onLogout();
                  removeToken();
                }}
                className="w-full flex items-center justify-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                <span className="font-medium">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <div className="w-64 bg-white shadow-lg border-r border-gray-200 flex flex-col">
      <div className="flex items-center p-4 border-b border-gray-200">
        <div className="flex items-center justify-center w-full">
          <img
            src={logoTransparent}
            alt="Calbar Logo"
            className="h-12 w-auto"
          />
        </div>
      </div>
      <nav className="flex-1 px-4 py-6 space-y-2">
        {menuItems.map((item) => {
          const isActive =
            currentPath === item.path ||
            (item.isDefault && currentPath === "/");
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors duration-200 ${
                isActive
                  ? "bg-primary-50 text-primary-700 border-l-4 border-primary-600"
                  : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              <span
                className={`${isActive ? "text-primary-600" : "text-gray-400"}`}
              >
                {item.icon}
              </span>
              <span className="font-medium">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-200">
        <button
          onClick={() => {
            onLogout();
          }}
          className="w-full flex items-center justify-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
